import React from "react"
import { ProviderFinderParam, ServiceFormat, useStringSearchParam } from "../../utils/providerFinderSearchUrl"
import { useIntl } from "react-intl"
import { MenuItem, Select } from "@carrotfertility/carotene-core"

export function ServiceFormatFilter(): JSX.Element {
  const intl = useIntl()
  const [serviceFormat, setServiceFormat] = useStringSearchParam(ProviderFinderParam.ServiceFormat)

  const selectOptions = [
    {
      value: ServiceFormat.All,
      label: intl.formatMessage({ defaultMessage: "All" })
    },
    {
      value: ServiceFormat.VirtualOnly,
      label: intl.formatMessage({ defaultMessage: "Virtual only" })
    },
    {
      value: ServiceFormat.InPerson,
      label: intl.formatMessage({ defaultMessage: "In-person" })
    },
    {
      value: ServiceFormat.InPersonAndVirtual,
      label: intl.formatMessage({ defaultMessage: "In-person offering virtual services" })
    }
  ]

  return (
    <Select
      required
      value={serviceFormat || ""}
      onChange={(event) => setServiceFormat(event.target.value)}
      aria-label={intl.formatMessage({ defaultMessage: "Select service format" })}
      sx={{
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "transparent"
        }
      }}
    >
      {selectOptions.map((option) => (
        <MenuItem value={option.value} key={option.value || "default"}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  )
}
